// extracted by mini-css-extract-plugin
export default {"root--elevated":"IUT0p_geTjk9iVlBV6yk"};